import React, {Suspense} from 'react';
import {Props} from './ac-private-route.proptypes';
import {Route, Redirect} from 'react-router-dom';
import clsx from 'clsx';

// Imports => Constants
import {REDIRECT_ROUTE} from '@asdf-constants';

const _CLASSES = {
  MAIN: 'ac-private-route',
};

// PrivateRoute
const PrivateRoute = ({authorized, forbidden, component: Component, redirect, ...rest}) => {
  return (
    <Route
      {...rest}
      render={props => {
        if (!forbidden || (forbidden && authorized)) {
          return <Suspense><Component {...props} /></Suspense>;
        } else if (
          !authorized &&
          props.location.pathname !== redirect.path &&
          window.location.pathname !== redirect.path
        ) {
          return (
            <Redirect
              from={props.location.pathname}
              to={{
                pathname: redirect.path,
                state: {from: props.location},
              }}
            />
          );
        } else {
          return null;
        }
      }}
    />
  );
};

const AcPrivateRoute = ({authorized, forbidden, component, redirect = REDIRECT_ROUTE, ...rest}) => {
  return (
    <PrivateRoute
      authorized={authorized}
      forbidden={forbidden}
      component={component}
      redirect={redirect}
      {...rest}
    />
  );
};

AcPrivateRoute.displayName = 'AcPrivateRoute';
AcPrivateRoute.propTypes = Props;

export {AcPrivateRoute};
export default AcPrivateRoute;
